import { localText, registerClass } from "@serenity-is/corelib";
import { AddonTextWithIcon } from "./AddonTextWithIcon";
import { EditorAddonUtils } from "./EditorAddonUtils";

export function FormTextAddon(props: {
    text: string,
    addonKey?: string;
    before?: boolean,
    cssClass?: string,
    icon?: string;
    hint?: string;
    editorElement?: HTMLElement
}): HTMLElement {
    const { addonKey, cssClass, editorElement, before, hint, text, icon } = props;

    const addon = (
        <div class={["form-text", cssClass]} title={!!hint && localText(hint, hint)}
            data-addonkey={!!addonKey && addonKey} data-addonfor={editorElement?.id}>

            <AddonTextWithIcon text={text} icon={icon} />
        </div>
    ) as HTMLElement;


    EditorAddonUtils.appendToInputVStack(editorElement, addon, before);
    return addon;
}

registerClass(FormTextAddon, 'Serenity.FormTextAddon');